import {componentConfig, componentLoader} from "../../lib/component_initializer";
import {Dropdown} from "./dropdown";

export const dropdownLoader = function (options = {}) {
    componentLoader(componentConfig(Dropdown, Dropdown.config.componentTypeKey, Dropdown.config.baseHtmlClass), options);
};
